// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"e2199cd9","37":"e2199cd9","320":"e2199cd9","933":"e2199cd9"}[chunkId] + ".chunk.css";
};